/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import React from 'react';
import {ScrollView, View, Text} from 'react-native';
import {ElementBox, Element, height, width, notchBottom} from '@components/frame';
import {isIOS, isPhone} from '@helpers';
import ColorWrapper from '@styles/colors';
import {font} from '@styles/fonts';

const phrase = 'The quick brown fox jumps over the lazy dog';

const WrappContent = (props) => {
  const {scale, C} = props;
  const bgColor = isIOS
    ? 'rgba(124, 252, 154, 0.5)'
    : 'rgba(252, 250, 184,0.5)';
  const color = isIOS ? 'rgba(255, 0, 0, 0.5)' : 'rgba(0, 122, 255, 0.5)';
  return (
    <ElementBox>
      <Element
        {...{
          configMobile: {
            width: width - scale(18),
            position: {
              top: 162,
              left: 18,
            },
          },
          skipPriority: true,
          config: {
            width: 660,
            position: {
              top: 162,
            },
            horizontalCenter: 0,
          },
        }}>
        <ScrollView
          style={{
            height: height - scale(162) - notchBottom,
            width: isPhone ? width - scale(32) : scale(660),
          }}>
          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Large Title
            </Text>
            <Text
              style={{
                ...font['Large Title'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Title 1
            </Text>
            <Text
              style={{
                ...font['Title 1'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Title 2
            </Text>
            <Text
              style={{
                ...font['Title 2'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Headline
            </Text>
            <Text
              style={{
                ...font.Headline,
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>Body</Text>
            <Text
              style={{
                ...font.Body,
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Subhead 1
            </Text>
            <Text
              style={{
                ...font['Subhead 1'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Subhead 2
            </Text>
            <Text
              style={{
                ...font['Subhead 2'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Button 1
            </Text>
            <Text
              style={{
                ...font['Button 1'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Button 2
            </Text>
            <Text
              style={{
                ...font['Button 2'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Button 3
            </Text>
            <Text
              style={{
                ...font['Button 3'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Footnote
            </Text>
            <Text
              style={{
                ...font.Footnote,
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Caption 1
            </Text>
            <Text
              style={{
                ...font['Caption 1'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>
              Caption 2
            </Text>
            <Text
              style={{
                ...font['Caption 2'],
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>Flag</Text>
            <Text
              style={{
                ...font.Flag,
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>

          <View style={{marginBottom: scale(20)}}>
            <Text style={{...font['Subhead 2'], color: '#717171'}}>Small</Text>
            <Text
              style={{
                ...font.Small,
                backgroundColor: bgColor,
                color: color,
              }}
              numberOfLines={1}>
              {phrase}
            </Text>
          </View>
        </ScrollView>
      </Element>
    </ElementBox>
  );
};

export default ColorWrapper(WrappContent);
